import { useState } from "react"
import SelectState from "./SelectState";


const InitialLandingPage = () => {
    const [, setIsOpen] = useState(false);
    const stateManager = () => {
        setIsOpen(false)
      }
      return (
    <div>
            <SelectState
                isOpen={true}
                stateManager={stateManager}
                heading={"Welcome to Credental!"}
                description={"Please select the state you would like to credential in."}
                buttonName={"Start Credentialing"}
                requireName={true}
            />
    </div>
      )
}

export default InitialLandingPage